export default "__VITE_ASSET__BWmviPtW__"